import React, { useEffect, useState } from "react";
import axios from "axios";
import "../assets/testimonials.css";
import LatestNews from "./LatestNews";
import ContactSection from "./ContactSection";
import OwlCarousel from "react-owl-carousel";

interface TestimonialItem {
  id: number;
  name: string;
  title: string;
  company: string;
  testimonial_text: string;
  external_link: string;
  image: string;
  sort_order: number;
  is_featured: number;
  status: "active" | "inactive";
  createdAt: string;
  updatedAt: string;
}

const API_URL =
  import.meta.env.VITE_LYRAZONE_BASE_URL || "http://localhost:5000/api";
const IMAGE_URL =
  import.meta.env.VITE_LYRAZONE_IMAGE_URL || "http://localhost:5000";

const Testimonials: React.FC = () => {
  const [featuredTestimonials, setFeaturedTestimonials] = useState<
    TestimonialItem[]
  >([]);
  const [allTestimonials, setAllTestimonials] = useState<TestimonialItem[]>([]);
  const [loading, setLoading] = useState(true);

  const getTestimonialImage = (fileName?: string) => {
    if (!fileName) return "/images/client/default-avatar.jpg";
    return `${IMAGE_URL}/uploads/testimonials/${fileName}`;
  };

  const fetchTestimonials = async () => {
    try {
      setLoading(true);

      const response = await axios.get(`${API_URL}/admin/testimonials/public`, {
        withCredentials: true,
      });

      setFeaturedTestimonials(response.data?.data?.featured || []);
      setAllTestimonials(response.data?.data?.all || []);
    } catch (error) {
      console.error("fetchTestimonials error:", error);
      setFeaturedTestimonials([]);
      setAllTestimonials([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTestimonials();
  }, []);

  return (
    <>
      <div id="home-p" className="home-p pages-head5 text-center">
        <div className="container"></div>
      </div>

      <div className="container">
        <div className="row title-bar">
          <div className="col-md-12">
            <h1 className="wow fadeInUp">Our Client Reviews</h1>
            <div className="heading-border"></div>
            <p className="wow fadeInUp" data-wow-delay="0.4s">
              We are a bunch of people who embody the united spirit of our Team
              Adventure.
            </p>
          </div>
        </div>
      </div>

      <section id="testimonials-p1" className="bg-parallax testimonials-p1-bg">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-8"></div>
            <div className="col-md-4 bg-gradiant testimonials-p1-pos">
              <div className="testimonials-p1-cont">
                {loading ? (
                  <div className="testimonial">
                    <blockquote>
                      <p>Loading testimonials...</p>
                    </blockquote>
                  </div>
                ) : featuredTestimonials.length > 0 ? (
                  <OwlCarousel
                    className="text-center owl-theme"
                    loop
                    margin={10}
                    nav
                    items={1}
                    autoplay
                  >
                    {featuredTestimonials.map((testimonial) => (
                      <div key={testimonial.id} className="testimonial">
                        <img
                          src={getTestimonialImage(testimonial.image)}
                          alt={testimonial.name}
                          className="img-fluid rounded-circle"
                        />
                        <blockquote>
                          <p>{testimonial.testimonial_text}</p>
                        </blockquote>
                        <div className="testimonial-author">
                          <p>
                            <strong>{testimonial.name}</strong>
                            <span>{testimonial.title}</span>
                          </p>
                        </div>
                      </div>
                    ))}
                  </OwlCarousel>
                ) : (
                  <div className="testimonial">
                    <blockquote>
                      <p>No featured testimonials available.</p>
                    </blockquote>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="client" className="client testimonials-p2">
        <div className="container">
          <div className="row">
            {loading ? (
              <div className="col-12 text-center">
                <p>Loading testimonials...</p>
              </div>
            ) : allTestimonials.length > 0 ? (
              allTestimonials.map((client) => (
                <div
                  className="col-lg-3 col-md-6 col-sm-6 col-12"
                  key={client.id}
                >
                  <div className="client-cont">
                    <div className="client-head">
                      <a
                        href={client.external_link || "#"}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="client-image-link"
                      >
                        <img
                          src={getTestimonialImage(client.image)}
                          className="img-fluid"
                          alt={client.name}
                        />
                      </a>

                      <div className="client-meta">
                        <h5>{client.name}</h5>
                        <h6>{client.title}</h6>
                      </div>
                    </div>

                    <i className="fa fa-quote-left"></i>
                    <p>{client.testimonial_text}</p>

                    {client.external_link ? (
                      <a
                        href={client.external_link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="client-link"
                      >
                        <i className="fa fa-arrow-circle-o-right"></i> Learn
                        More
                      </a>
                    ) : (
                      <span>{client.company}</span>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center">
                <p>No testimonials available.</p>
              </div>
            )}
          </div>
        </div>
      </section>

      <ContactSection />
      <LatestNews />
    </>
  );
};

export default Testimonials;
